import styled, { theme } from "../../theme";
import Box from "./box";

/**
 * @deprecated Use native HTML elements with tailwind classes
 */
export const Text = styled(Box)`
  line-height: ${theme.lineHeight};
`;

Text.displayName = "Text";

export default Text;
